import { render, staticRenderFns } from "./EchangesClientsList.vue?vue&type=template&id=6f2d14d1&"
import script from "./EchangesClientsList.vue?vue&type=script&lang=js&"
export * from "./EchangesClientsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports